// extracted by mini-css-extract-plugin
module.exports = {"body":"ButtonMenu_body__2FXmr","nav":"ButtonMenu_nav__osWIw","navActiv":"ButtonMenu_navActiv__31Ar_"};